module.exports = "pegasus/assets/themelp1/charity/111.png";